import Vue from 'vue'

export const caseTemplateRender = {
    data(){
        return { template:''}
    },
    render(createElement){
        if (!this.template) {
            return createElement('div', { class:'text-center' }, [
                createElement('b-spinner', {
                    class: 'page_loader_spinner',
                    attrs: { type: 'grow'}
                }, 'Загрузка...')
            ])
        } else {
            return this.template()
        }
    },
    beforeMount() {
        this.compileContent()
    },
    updated(){
        if(this.template == ''){
            this.compileContent()
        } else {
            this.caseTemplateRenderCallback()
        }
    },
    methods: {
        compileContent(){
            let content = this.content
            if(content){
                setTimeout(() => {
                    this.template = Vue.compile(`
                        <section class="template_wrapper" ref="template_wrapper">
                            ${content}
                            <ScrollTop />
                            <Pagination casesNum=15 />
                        </section>
                    `).render
                }, Math.floor(Math.random()*1000))
            } else {
                this.$router.push('/404')
            }
        }
    }
}